/*
 * settingsPrefs — the learner's Prepare Up preferences, kept in this browser.
 *
 * The backend profile has a fixed schema (name, avatar, links, skills…), so the
 * preferences Settings adds live here. Some are read by the app today:
 *   practiceMode / difficulty / sessionSize → the "Practice this" dialog defaults
 *   interview* + aiPersonalization          → Interview Setup defaults
 *   reducedMotion                           → the shell's reduced-motion class
 * The rest are saved for features that will read them (the Settings page says so).
 */
const KEY = 'pu_settings_v1';

export const PREF_DEFAULTS = {
  // profile (not in the backend profile schema yet)
  headline: '', currentRole: '', experienceLevel: '',
  // learning
  interests: [], topics: [], learningStyle: 'mixed', frequency: 'few-week', difficulty: null, interviewPrep: 'balanced',
  // practice
  practiceMode: 'mcq', mixedPractice: true, sessionSize: 5, flashcardShuffle: true, caseStudyHints: true,
  // interviews
  interviewRoleId: '', interviewLevel: '', interviewType: 'video', aiPersonalization: true,
  // notifications
  notifyPractice: true, notifyLearning: true, notifyInterview: true, notifyProgress: true, notifyWeekly: true, notifyProduct: false,
  // appearance
  reducedMotion: false,
  // privacy
  shareUsageForImprovement: true,
  // progress — weekly goals (Progress → Goals)
  weeklyDays: 4, weeklyQuestions: 50,
};

export const loadPrefs = () => {
  try { return { ...PREF_DEFAULTS, ...(JSON.parse(localStorage.getItem(KEY) || '{}') || {}) }; } catch { return { ...PREF_DEFAULTS }; }
};
export const savePrefs = (prefs) => {
  try { localStorage.setItem(KEY, JSON.stringify(prefs)); } catch { /* private mode */ }
  try { window.dispatchEvent(new CustomEvent('pu-prefs', { detail: prefs })); } catch { /* old browsers */ }
};

/** Interview Setup defaults from the learner's preferences. */
export const interviewDefaults = () => {
  const p = loadPrefs();
  return {
    ...(p.interviewRoleId ? { roleId: p.interviewRoleId } : {}),
    ...(p.interviewLevel ? { level: p.interviewLevel } : {}),
    ...(p.interviewType === 'voice' || p.interviewType === 'video' ? { type: p.interviewType } : {}),
    ...(p.difficulty ? { difficulty: p.difficulty } : {}),
    personalize: p.aiPersonalization !== false,
  };
};
